import React, { useContext } from "react";
import { ArrowRight } from "lucide-react";
import { LanguageContext } from "../context/LanguageContext";
import { Section, SectionHeader, Eyebrow, Lead } from "./ui/Section";
import { Button } from "./ui/Button";

// `embedded` renders it as a section of the landing page (h2, no closing CTA — the landing has its own).
const Benefits = ({ embedded = false }) => {
  const { benefitsTitle, benefitsDesc, benefitsList, benefitsFooterTitle, benefitsFooterDesc, benefitsDemo, benefitsButton, language } =
    useContext(LanguageContext);
  const prefix = language === "es" ? "/es" : "";

  return (
    <>
      <Section tone="mist" id="benefits">
        {embedded ? (
          <SectionHeader title={benefitsTitle} lead={benefitsDesc} />
        ) : (
          <div className="max-w-3xl">
            <Eyebrow>WashWorth</Eyebrow>
            <h1 className="mb-0 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy md:text-6xl">
              {benefitsTitle}
            </h1>
            <Lead>{benefitsDesc}</Lead>
          </div>
        )}

        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {benefitsList.map((benefit, index) => (
            <div key={index} className="flex gap-5 rounded-2xl bg-white p-8">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-brand-foam">
                {React.cloneElement(benefit.icon, { className: "h-5 w-5 text-brand-teal" })}
              </div>
              <div>
                <h3 className="mb-2 font-display text-lg font-bold text-brand-navy">{benefit.title}</h3>
                <p className="mb-0 leading-relaxed text-slate-600">{benefit.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      {!embedded && (
        <Section tone="dark">
          <div className="max-w-3xl">
            <h2 className="mb-0 font-display text-3xl font-bold tracking-tight text-white md:text-4xl">{benefitsFooterTitle}</h2>
            <p className="mb-0 mt-4 leading-relaxed text-white/70">{benefitsFooterDesc}</p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button variant="inverse" size="lg" to={`${prefix}/register-owner`}>
                {benefitsButton}
                <ArrowRight className="h-4 w-4" />
              </Button>
              <Button variant="inverse-outline" size="lg" to={`${prefix}/support`}>
                {benefitsDemo}
              </Button>
            </div>
          </div>
        </Section>
      )}
    </>
  );
};

export default Benefits;
